export function withTrailingSlash(route: string): string {
    return route[route.length - 1] === '/' ? route : `${route}/`;
}
